import jwtAuthAxios from "../../services/jwtAuth";
import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";

export const getSyncLog = createAsyncThunk("logs/getSyncLog", async () => {
  let token = await localStorage.getItem("auth_token");
  jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
  const response = await jwtAuthAxios.get("v1/sync/log");
  return response.data;
});

export const syncTransactionParam = createAsyncThunk("logs/syncTransactionParam", async (param) => {
  let token = await localStorage.getItem("auth_token");
  jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
  const response = await jwtAuthAxios.post("v1/sync/transaction",param);
  return response.data;
});
export const syncAction = createAsyncThunk("logs/syncAction", async (param) => {
  let token = await localStorage.getItem("auth_token");
  jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
  const response = await jwtAuthAxios.post("v1/sync/action",param);
  return response.data;
});

const initialState = {
  loading: false,
  dataSync: [],
  transaction:[],
    action:{}
};

const syncSlice = createSlice({
  name: "sync",
  initialState: initialState,
  extraReducers: (builder) => {
    builder
        .addCase(getSyncLog.pending, (state) => {
          state.loading = true;
        })
        .addCase(getSyncLog.fulfilled, (state, action) => {
          state.dataSync = action.payload;
          state.loading = false;
        })
        .addCase(getSyncLog.rejected, (state, action) => {
          state.loading = false;
          console.error("Error during getMatkul:", action.error);
        })
    builder
        .addCase(syncTransactionParam.pending, (state) => {
          state.loading = true;
        })
        .addCase(syncTransactionParam.fulfilled, (state, action) => {
          state.transaction = action.payload;
          state.loading = false;
        })
        .addCase(syncTransactionParam.rejected, (state, action) => {
          state.loading = false;
        })
    builder
        .addCase(syncAction.pending, (state) => {
          state.loading = true;
        })
        .addCase(syncAction.fulfilled, (state, action) => {
          state.action = action.payload;
          state.loading = false;
        })
        .addCase(syncAction.rejected, (state, action) => {
          state.loading = false;
        })

    ;
  },
});

export const syncSelectors = (state) => state.sync;
export default syncSlice.reducer;
